// VoK MUI base styles
import colors from "app/assets/theme-dark/base/colors";
import borders from "app/assets/theme-dark/base/borders";
import boxShadows from "app/assets/theme-dark/base/boxShadows";

// VoK MUI helper functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem";

const {background} = colors;
const {borderRadius} = borders;
const {tabsBoxShadow} = boxShadows;

const tabs = {
    styleOverrides: {
        root: {
            position: "relative",
            backgroundColor: background.default,
            borderRadius: borderRadius.lg,
            minHeight: "unset",
            padding: pxToRem(4),
        },

        flexContainer: {
            height: "100%",
            position: "relative",
            zIndex: 10,
        },

        fixed: {
            overflow: "unset !important",
            overflowX: "unset !important",
        },

        vertical: {
            "& .MuiTabs-indicator": {
                width: "100%",
            },
        },

        indicator: {
            height: "100%",
            borderRadius: borderRadius.md,
            backgroundColor: background.dark,
            boxShadow: tabsBoxShadow.indicator,
            transition: "all 500ms ease",
        },
    },
};

export default tabs;
